module.exports = __webpack_public_path__ + "img/bg_fantasy.2f770264.png";